import SolidButton from '@/components/Common/Button/SolidButton'
import { formatDate } from '@/lib/utils/formatDate'
import { useTranslation } from 'react-i18next'
import { useCompanyContext } from '@/lib/providers/CompanyProvider'
import dayjs from 'dayjs'
import utc from 'dayjs/plugin/utc'
import timezone from 'dayjs/plugin/timezone'
import { useMemo } from 'react'

dayjs.extend(utc)
dayjs.extend(timezone)

const ApplicationBefore = ({
  startAt,
  isKtpDomain = false,
}: {
  startAt: string
  isKtpDomain?: boolean
}) => {
  const { t, i18n } = useTranslation('common')
  const { timezone } = useCompanyContext()

  const timeString = useMemo(() => {
    // 문구(i18n)와 날짜 포맷의 언어 소스를 i18n.language 로 통일한다.
    // 회사 설정 language 는 'ko-KR' 처럼 region 이 붙어올 수 있어 원본 정확 비교하면
    // 'ko-KR' === 'ko' 가 false 가 되어 한국어 화면에도 영어 날짜가 섞이는 버그가 있었다.
    if (i18n.language === 'ko') {
      return formatDate(startAt, { format: 'YY년 MM월 DD일 HH시' })
    }
    // en: ensure month is English (e.g., Oct 18)
    return dayjs(startAt).tz(timezone).locale('en').format('HH:mm [on] MMM DD, YYYY.')
  }, [startAt, i18n.language, timezone])

  // KTP 디자인용 OPEN 시점 표기 (예: "4월 8일 오전 1시 OPEN!")
  const ktpOpenString = useMemo(() => {
    const d = dayjs(startAt).tz(timezone)
    const hour = d.hour()
    const meridiem = hour < 12 ? '오전' : '오후'
    const hour12 = hour % 12 === 0 ? 12 : hour % 12
    return `${d.month() + 1}월 ${d.date()}일 ${meridiem} ${hour12}시 OPEN!`
  }, [startAt, timezone])

  return (
    <>
      <div className="flex items-center justify-center">
        {isKtpDomain ? (
          <p className="text-sm font-semibold text-[#1C1C1C] lg:text-lg">
            <span className="text-[#3385FF]">{ktpOpenString} </span>
            협력과제 확인하고 프로그램에 참여해보세요
          </p>
        ) : (
          <p
            className="text-sm font-semibold text-normal lg:text-lg"
            dangerouslySetInnerHTML={{
              __html: t('cta.before.message', {
                date: `<span class='text-primary-normal'>${timeString}</span>`,
              }),
            }}
          />
        )}
      </div>
      <div className="w-full lg:max-w-[160px]">
        <SolidButton
          className={`!h-10 !w-full lg:!h-11 ${isKtpDomain ? '!bg-[#D9D9D9] !text-[#8C8C8C]' : ''}`}
          disabled={true}>
          {isKtpDomain ? '모집 준비 중' : t('cta.before.button')}
        </SolidButton>
      </div>
    </>
  )
}

export default ApplicationBefore
